<script>
    import { Row, Col, Button } from 'sveltestrap'
    import Icon from 'svelte-awesome'
    import { plus } from 'svelte-awesome/icons'
    import FormAlerts from '../FormAlerts.svelte'
    import FormSavingButtons from '../FormSavingButtons.svelte'
    import VenueInfo from './VenueInfo.svelte'

    export let context
    export let saving
    export let schoolId

    const addVenue = () => {
        context.form.arenas = [
            ...context.form.arenas,
            {
                $create: true,
                id: context.form.arenas.length,
                attributes: {
                    latitude: '',
                    longitude: '',
                    icon: '',
                    name: ''
                },
                meta: {
                    schoolId,
                    state: 'published'
                }
            }
        ]
    }
</script>

<h1>Venues</h1>

<p>
    Please add each venue that your sports team considers their home venue. The icon will be displayed for that venue on
    the map feature of the app. Need help finding the latitude and longitude of a venue? Learn how to find it
    <a href="https://www.latlong.net/" target="_blank">here</a>.
</p>

<p>Note: Venues are required for each team that will be added on the teams' page*.</p>

{#each context.form.arenas as arena, index (arena.id)}
    <Row class="mb-3">
        <Col>
            <VenueInfo bind:context formKey="arenas" {index} on:change />
        </Col>
    </Row>
{/each}

<Row>
    <Col />
</Row>

<Row>
    <Col>
        <p>
            <Button on:click={addVenue}>
                Add another venue
                <Icon data={plus} />
            </Button>
        </p>
    </Col>
</Row>

<FormAlerts bind:alerts={context.alerts} />

<FormSavingButtons {context} {saving} on:save on:nextStepClicked on:previousStepClicked />
